import React, { useEffect, useState } from 'react'
import { Model } from '../../../Shared-ui/Types/common'
import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material'
import CloseIcon from "@mui/icons-material/Close";
import variables from "../../../assets/styles/variables.module.scss";
import { NotSelected } from '../../../Constant/Setting';
import { isOnlyAlphabetsNumbers } from '../../../Shared-ui/utils/Common/Common';
import { useDispatch } from 'react-redux';
import { CREATE_MODELS, UPDATE_MODELS } from '../../../Services/Endpoint';
import { StartLoading, StopLoading } from '../../../Shared-ui/Store/LoadingReducer/LoaderActions';
import { ShowError, ShowSuccess } from '../../../Shared-ui/Store/MessageReducer/MsgActions';
import MetaInstance from '../../../Services/AxiosInstance/MetaInstance';


interface MyComponentProps {
    data: Model | null
    handleCancel: () => void
}
const ModelForm: React.FC<MyComponentProps> = (props) => {

    const modelInitial = {
        name: "",
        modelName: "",
        provider: NotSelected,
        apiKey: "",
        description: "",
        azureEndpoint: "",
        apiVersion: "",
        deploymentName: "",
    }
    const [modelErr, setModelErr] = useState({
        name: { error: "", value: false },
        modelName: { error: "", value: false },
        endpoint: { error: "", value: false },
        provider: { error: "", value: false },
        apiKey: { error: "", value: false },
        description: { error: "", value: false },
        azureEndpoint: { error: "", value: false },
        apiVersion: { error: "", value: false },
        deploymentName: { error: "", value: false },
    })
    const [modelNames, setModelName] = useState(["OpenAI", "Gemini", "Anthropic", "Azure"])
    const [model, setModel] = useState<Model>(modelInitial);
    const [isEditing, setIsEditing] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        if (props.data) {
            setModel(props.data)
            setIsEditing(true)
        } else {
            setModel(modelInitial);
            setIsEditing(false)
        }
    }, [])


    const createModel = async () => {
        if (!validateModel()) return
        try {
            dispatch(StartLoading())
            const data = await MetaInstance.post(`${CREATE_MODELS}`, model).then(res => res?.data?.detail)
            dispatch(ShowSuccess(data?.response));
            handleCancel()
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail?.response));
        } finally {
            dispatch(StopLoading())

        }

    };
    const updateModel = async () => {
        if (!validateModel()) return
        try {
            dispatch(StartLoading())
            const data = await MetaInstance.put(`${UPDATE_MODELS}`, model).then(res => res?.data?.detail)
            dispatch(ShowSuccess(data?.response));
            handleCancel()
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail?.response));
        } finally {
            dispatch(StopLoading())

        }

    };

    const validateModel = () => {
        // name
        if (!model.name) {
            setModelErr((preVal) => ({
                ...preVal,
                name: { error: "Enter The Name", value: true },
            }));
            return false;
        }else {
            setModelErr((preVal) => ({
                ...preVal,
                name: { error: "", value: false },
            }));
        }
        // modelName
        if (!model.modelName) {
            setModelErr((preVal) => ({
                ...preVal,
                modelName: { error: "Enter The model name", value: true },
            }));
            return false;
        } else {
            setModelErr((preVal) => ({
                ...preVal,
                modelName: { error: "", value: false },
            }));
        }



        // model provider
        if (model.provider === NotSelected) {
            setModelErr((preVal) => ({
                ...preVal,
                provider: { error: "Please select Provide", value: true },
            }));
            return false;
        } else if (model.provider === "Azure") {
            if (!model.azureEndpoint) {
                setModelErr((preVal) => ({
                    ...preVal,
                    azureEndpoint: { error: "PLease enter azureEndpoint", value: true },
                }));
                return false;
            } else {
                setModelErr((preVal) => ({
                    ...preVal,
                    azureEndpoint: { error: "", value: false },
                }));
            }
            if (!model.apiVersion) {
                setModelErr((preVal) => ({
                    ...preVal,
                    apiVersion: { error: "PLease enter apiVersion", value: true },
                }));
                return false;
            } else {
                setModelErr((preVal) => ({
                    ...preVal,
                    apiVersion: { error: "", value: false },
                }));
            }
            if (!model.deploymentName) {
                setModelErr((preVal) => ({
                    ...preVal,
                    deploymentName: { error: "PLease enter deploymentName", value: true },
                }));
                return false;
            } else {
                setModelErr((preVal) => ({
                    ...preVal,
                    deploymentName: { error: "", value: false },
                }));
            }

        } else {
            setModelErr((preVal) => ({
                ...preVal,
                provider: { error: "", value: false },
            }));
        }

        if (!model.apiKey) {
            setModelErr((preVal) => ({
                ...preVal,
                apiKey: { error: "Enter The apiKey", value: true },
            }));
            return false;

        } else {
            setModelErr((preVal) => ({
                ...preVal,
                apiKey: { error: "", value: false },
            }));
        }
        // endpoint
        if (!model.endpoint) {
            setModelErr((preVal) => ({
                ...preVal,
                endpoint: { error: "Enter The endpoint", value: true },
            }));
            return false;

        } else {
            setModelErr((preVal) => ({
                ...preVal,
                endpoint: { error: "", value: false },
            }));
        }
        return true

    };




    const handleCancel = () => {
        props.handleCancel()
        setModel(modelInitial)
        setIsEditing(false);
    }
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setModel((preVal) => ({ ...preVal, [name]: value }))
    };

    const handleProviderChange = (event: SelectChangeEvent) => {
        const value = event.target.value as string
        setModel((preVal) => ({ ...preVal, provider: value }))
    };

    return (
        <Box
            sx={{
                "&::before": {
                    content: '""',
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 7,
                },
            }}
        >
            <Box
                sx={{
                    width: "500px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    pt: "10px",
                    position: "fixed",
                    right: "0",
                    top: "0",
                    height: "100vh",
                    background: variables.whiteColor,
                    padding: "20px 30px",
                    zIndex: 8,
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        height: "100%",
                    }}
                >
                    <Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography variant="h6" gutterBottom>
                                {isEditing ? "Edit AI Model" : "Add AI Model"}
                            </Typography>
                            <IconButton aria-label="close" onClick={() => props.handleCancel()}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 3,
                                mt: 2,
                                pt: "5px",
                                height: "calc(100vh - 160px)",
                                overflow: "auto",
                            }}
                        >
                            <FormControl fullWidth variant="outlined" required error={modelErr.name.value}>
                                <InputLabel htmlFor="name" shrink sx={{ background: "#fff", px: 0.5 }}>
                                    Name
                                </InputLabel>
                                <TextField
                                    id="name"
                                    name="name"
                                    inputProps={{ maxLength: 25 }}
                                    placeholder="Enter the name"
                                    sx={{ background: "white" }}
                                    value={model.name}
                                    onChange={handleChange}
                                    error={modelErr.name.value}
                                    helperText={modelErr.name.error}
                                    disabled={isEditing}
                                />
                            </FormControl>
                            <FormControl fullWidth variant="outlined" required error={modelErr.modelName.value}>
                                <InputLabel htmlFor="name" shrink sx={{ background: "#fff", px: 0.5 }}>
                                    Model Name
                                </InputLabel>
                                <TextField
                                    id="modelName"
                                    name="modelName"
                                    inputProps={{ maxLength: 25 }}
                                    placeholder="Enter the model name"
                                    sx={{ background: "white" }}
                                    value={model.modelName}
                                    onChange={handleChange}
                                    error={modelErr.modelName.value}
                                    helperText={modelErr.modelName.error}
                                />
                            </FormControl>

                            <FormControl fullWidth variant="outlined" required error={modelErr.endpoint.value}>
                                <InputLabel htmlFor="modelName" shrink sx={{ background: "#fff", px: 0.5 }}>
                                    Endpoint
                                </InputLabel>
                                <TextField
                                    id="endpoint"
                                    name="endpoint"
                                    placeholder="Enter the endpoint"
                                    sx={{ background: "white" }}
                                    value={model.endpoint}
                                    error={modelErr.endpoint.value}
                                    helperText={modelErr.endpoint.error}
                                    onChange={handleChange}
                                />
                            </FormControl>

                            <FormControl fullWidth variant="outlined" required error={modelErr.provider.value}>
                                <InputLabel id="provider-label" shrink sx={{ background: "#fff", px: 0.5 }}>
                                    Provider
                                </InputLabel>
                                <Select
                                    labelId="provider-label"
                                    id="provider"
                                    name="provider"
                                    value={model.provider || NotSelected}
                                    onChange={handleProviderChange}
                                    label="Provider"
                                    error={modelErr.provider.value}
                                >

                                    <MenuItem value={NotSelected}>Please select model</MenuItem>
                                    {modelNames.map((modelName, index) => (
                                        <MenuItem value={modelName} key={index}>{modelName}</MenuItem>

                                    ))}

                                </Select>
                            </FormControl>

                            {model.provider !== "Azure" && (
                                <FormControl fullWidth variant="outlined" required error={modelErr.apiKey.value}>
                                    <InputLabel htmlFor="apiKey" shrink sx={{ background: "#fff", px: 0.5 }}>
                                        API Key
                                    </InputLabel>
                                    <TextField
                                        id="apiKey"
                                        name="apiKey"
                                        placeholder="Enter the API key"
                                        sx={{ background: "white" }}
                                        value={model.apiKey}
                                        onChange={handleChange}
                                        error={modelErr.apiKey.value}
                                        helperText={modelErr.apiKey.error}
                                    />
                                </FormControl>
                            )}

                            {model.provider === "Azure" && (
                                <>
                                    <FormControl fullWidth variant="outlined" required error={modelErr.azureEndpoint.value}>
                                        <InputLabel htmlFor="azureEndpoint" shrink sx={{ background: "#fff", px: 0.5 }}>
                                            Azure Endpoint
                                        </InputLabel>
                                        <TextField
                                            id="azureEndpoint"
                                            name="azureEndpoint"
                                            placeholder="Enter Azure Endpoint"
                                            sx={{ background: "white" }}
                                            value={model.azureEndpoint}
                                            error={modelErr.azureEndpoint.value}
                                            helperText={modelErr.azureEndpoint.error}
                                            onChange={handleChange}
                                        />
                                    </FormControl>

                                    <FormControl fullWidth variant="outlined" required error={modelErr.apiVersion.value}>
                                        <InputLabel htmlFor="apiKeyVersion" shrink sx={{ background: "#fff", px: 0.5 }}>
                                            API Key Version
                                        </InputLabel>
                                        <TextField
                                            id="apiVersion"
                                            name="apiVersion"
                                            placeholder="Enter API Key Version"
                                            sx={{ background: "white" }}
                                            value={model.apiVersion}
                                            error={modelErr.apiVersion.value}
                                            helperText={modelErr.apiVersion.error}
                                            onChange={handleChange}
                                        />
                                    </FormControl>

                                    <FormControl fullWidth variant="outlined" required error={modelErr.deploymentName.value}>
                                        <InputLabel htmlFor="deploymentName" shrink sx={{ background: "#fff", px: 0.5 }}>
                                            Deployment Name
                                        </InputLabel>
                                        <TextField
                                            id="deploymentName"
                                            name="deploymentName"
                                            inputProps={{ maxLength: 200 }}
                                            placeholder="Enter Deployment Name"
                                            sx={{ background: "white" }}
                                            value={model.deploymentName}
                                            error={modelErr.deploymentName.value}
                                            helperText={modelErr.deploymentName.error}
                                            onChange={handleChange}
                                        />
                                    </FormControl>
                                </>
                            )}

                            <FormControl fullWidth variant="outlined" error={modelErr.description.value}>
                                <InputLabel htmlFor="description" shrink sx={{ background: "#fff", px: 0.5 }}>
                                    Description
                                </InputLabel>
                                <TextField
                                    id="description"
                                    name="description"
                                    placeholder="Enter the description"
                                    sx={{ background: "white" }}
                                    value={model.description}
                                    inputProps={{ maxLength: 200 }}
                                    error={modelErr.description.value}
                                    helperText={modelErr.description.error}
                                    onChange={handleChange}
                                    multiline
                                    rows={4}
                                />
                            </FormControl>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            gap: 2,
                            justifyContent: "flex-end",
                            position: "absolute",
                            bottom: 0,
                        }}
                    >
                        <Button
                            fullWidth
                            variant="outlined"
                            disableElevation
                            size="large"
                            sx={{
                                textTransform: "capitalize",
                            }}
                            onClick={() => props.handleCancel()}
                        >
                            Cancel
                        </Button>
                        {isEditing ? <Button
                            fullWidth
                            variant="contained"
                            disableElevation
                            size="large"
                            sx={{
                                textTransform: "capitalize",
                            }}
                            onClick={updateModel}
                        >
                            Save
                        </Button> :
                            <Button
                                fullWidth
                                variant="contained"
                                disableElevation
                                size="large"
                                sx={{
                                    textTransform: "capitalize",
                                }}
                                onClick={createModel}
                            >
                                Save
                            </Button>
                        }
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default ModelForm